import { Component } from '@angular/core';
import { IonicPage, NavController, ActionSheetController, NavParams } from 'ionic-angular';

import { Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-operador-infopedido',
  templateUrl: 'operador-infopedido.html',
})
export class OperadorInfopedidoPage {
  pedido:any={
    pedido:{
      codigo:'',
      initEntrega:'00-00-00T00:00:00',
      fimEntrega:'00-00-00T00:00:00'
    },
    cliente:{
      nome:''
    },
    separacao:{
      caixas:[]
    },
    items:[]
  };
  code:string='';
  postObj:any={};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    private api:Api,
    public user: User,
    private tools: Tools
  ) {
  }

  ionViewDidLoad() {
    this.pedido = this.navParams.get('item');
    console.log('ionViewDidLoad OperadorInfopedidoPage',this.pedido);
    this.buscarProdutos(this.pedido.items.map(e=>e.codigoBarra));
  }

  ligar(){
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Qual a forma de contato?',
      buttons: [
        {
          text: 'Ligação',
          handler: () => {
            window.open(`tel:${this.pedido.cliente.celular}`, '_system');
          }
        },
        {
          text: 'Whatsapp',
          handler: () => {
            // window.open("http://google.com",'_system', 'location=yes');
            // window.open(`https://api.whatsapp.com/send?phone=55${this.pedido.cliente.celular}&text=Olá!`,'_system');
            window.open(`whatsapp://send?phone=55${this.pedido.cliente.celular}&text=Olá`, "_system");
          }
        }
      ]
    });
    actionSheet.present();
  }

  buscarProdutos(codigosBarra){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    let self = this;
    var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';

    this.postObj = {codigos:codigosBarra};

    this.sendPost(urlBuscarProdutos,(result)=>{
      console.log(result);

      if(result.status && result.data && result.data.length>0){
        for(var x1 in result.data){

          var prod = this.pedido.items.find(f=>f.codigoBarra == result.data[x1].sku);
          if(prod && result.data[x1].linkId){
            prod.img = `http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`;
          }
        }

        // for(var x1 in this.pedido.items){
        //   var produto = result.produtos.find(e=>e.sku == this.pedido.items )
        // }

        setTimeout(() => {
          loading.dismiss();
        }, 500);

      }else{
        self.tools.showAlert('toast',`${result.msg}`,1500);
        loading.dismiss();
      }
    });
  }

  sendPost(url,callback){
    var self = this;
    this.api.sendPost(url,self.postObj,{},function(result){
      callback(result);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/operador-infopedido/operador-infopedido.ts